import { render, staticRenderFns } from "./ClientsCreateComponent.vue?vue&type=template&id=cb4211b4"
import script from "./ClientsCreateComponent.vue?vue&type=script&lang=js"
export * from "./ClientsCreateComponent.vue?vue&type=script&lang=js"
import style0 from "./ClientsCreateComponent.vue?vue&type=style&index=0&id=cb4211b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports